import { getNseCapTier } from './nseCapTier';

export interface HoldingsPlRowInput {
  stockCode: string;
  investedAmount: number;
  currentAmount: number;
  pnlAmount: number;
}

export interface BreezePortfolioKpiComputed {
  stockCount: number;
  largeCapPct: number;
  midCapPct: number;
  smallCapPct: number;
  unclassifiedCapPct: number;
  investedAmount: number;
  currentValue: number;
  profitLoss: number;
  profitLossPct: number | null;
}

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

/** Weight cap mix by current value (typical for allocation view). */
export function computeBreezePortfolioKpi(rows: HoldingsPlRowInput[]): BreezePortfolioKpiComputed {
  let invested = 0;
  let current = 0;
  let pnl = 0;
  let l = 0;
  let m = 0;
  let s = 0;
  let u = 0;

  for (const r of rows) {
    const inv = Number(r.investedAmount) || 0;
    const cur = Number(r.currentAmount) || 0;
    const p = Number(r.pnlAmount) || 0;
    invested += inv;
    current += cur;
    pnl += p;
    const tier = getNseCapTier(String(r.stockCode ?? ''));
    if (tier === 'LARGE') l += cur;
    else if (tier === 'MID') m += cur;
    else if (tier === 'SMALL') s += cur;
    else u += cur;
  }

  const tot = l + m + s + u;
  const pct = (x: number) => (tot > 0 ? round2((x / tot) * 100) : 0);

  return {
    stockCount: rows.length,
    largeCapPct: pct(l),
    midCapPct: pct(m),
    smallCapPct: pct(s),
    unclassifiedCapPct: pct(u),
    investedAmount: round2(invested),
    currentValue: round2(current),
    profitLoss: round2(pnl),
    profitLossPct: invested > 0 ? round2((pnl / invested) * 100) : null,
  };
}
